export default __webpack_public_path__ + "static/media/0000..0003.b57032c0.png";